export default __webpack_public_path__ + "static/datapath-f4c7a085b95835ce8b3cf333b1a4f441.png";